module.exports = __webpack_public_path__ + "static/media/slider-small-5.ef163a07.jpg";